// Centralised Google Ads + GA4 configuration.
// Update the conversion labels here when you create them in:
//   Google Ads → Tools → Conversions → New (Custom event)
//
// Each label looks like the part AFTER the slash in:
//   AW-17961361754/<this-part>
//
// While a label is "PLACEHOLDER_…", the corresponding tracker safely no-ops.

export const GOOGLE_ADS_ID = 'AW-17961361754';

// Pulled from frontend/.env at build time. Leave REACT_APP_GA4_ID empty until
// you create the GA4 property and add the ID. The GA4 init will skip cleanly.
export const GA4_ID = process.env.REACT_APP_GA4_ID || '';

// Conversion labels. Replace placeholders with the labels from Google Ads.
export const CONVERSION_LABELS = {
  contactForm: 'V4uGCPCAppgcENrC0vRC',          // already live
  consultation: 'HbGNCP3Bxa8cENrC0vRC',         // Consultation Booking
  whatsappClick: 'WrxVCM7p3q8cENrC0vRC',        // WhatsApp Click
  callClick: '9NvECJGe368cENrC0vRC',            // Call Click
  newsletter: 'PLACEHOLDER_NEWSLETTER'          // TODO: replace when ready
};

export const isLabelConfigured = (label) =>
  Boolean(label) && !label.startsWith('PLACEHOLDER_');
